import { Link } from "react-router-dom";
import { Users, Award, Landmark, Receipt, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { OrnamentDivider } from "./BrandGraphics";
import { WHY_DWG } from "../lib/landingContent";

const ICONS = { users: Users, award: Award, landmark: Landmark, receipt: Receipt };

export default function WhyDwg() {
  return (
    <section className="bg-[var(--bg)]" data-testid="section-why-dwg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-20">
        <Reveal className="max-w-2xl mx-auto text-center">
          <div className="eyebrow mb-2">{WHY_DWG.eyebrow}</div>
          <h2 className="font-serif text-3xl md:text-5xl text-[var(--ink)]" data-testid="why-dwg-title">{WHY_DWG.title}</h2>
          <OrnamentDivider className="mt-5" />
          <p className="mt-5 text-[var(--muted)] text-sm md:text-base">{WHY_DWG.subtitle}</p>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="why-dwg-grid">
          {WHY_DWG.points.map((pt, i) => {
            const Icon = ICONS[pt.icon] || Users;
            return (
              <Reveal key={pt.title} delay={i * 0.08}
                className="group bg-white rounded-[10px] border-[0.5px] border-[var(--line)] p-6 md:p-7 flex gap-5 hover:-translate-y-0.5 transition-transform duration-300">
                <div className="w-12 h-12 shrink-0 rounded-full border border-[var(--champagne)] flex items-center justify-center text-[var(--brand)] group-hover:bg-[var(--brand)] group-hover:text-[var(--dark-text)] transition-colors duration-300">
                  <Icon className="w-5 h-5" strokeWidth={1.4} />
                </div>
                <div data-testid={`why-dwg-point-${i}`}>
                  <h3 className="font-serif text-xl md:text-2xl text-[var(--ink)]">{pt.title}</h3>
                  <p className="mt-2 text-sm text-[var(--muted)] leading-relaxed">{pt.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal className="mt-8 text-center">
          <Link to={WHY_DWG.cta.to} className="btn btn-secondary group" data-testid="why-dwg-cta">
            {WHY_DWG.cta.label} <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
